import { TableRow, TableCell, Collapse, Box, Table, TableBody } from "@mui/material";
import React, { useEffect, useState } from "react";
import { LiquidProductionTATEnum } from "../../../common/enums/LiquidProductionTATEnum";
import { useUserContext } from "../../../contexts/user-context/UserContext";

import { TankHeaderRow } from "../common/TankHeaderRow";
import { CollapsibleCell } from "../common/CollapsibleCell";
import useNavigateTo from "../../../hooks/use-navigate-to/useNavigateTo";

import { getTankBatteryRoute, getTankRoute } from "../../../common/utilities/RouteHelpers";
import { UIViewEnum } from "../../../common/enums/UIViewEnum";
import { useRouteContext } from "../../../hooks/use-route-context/UseRouteContext";
import { TankBatteryTableModel } from "./TankBatteryTableViewUtils";
import { getTotalFromFeetAndInchesText } from "../../../common/utilities/FeetAndInches";
import _ from "lodash";


export type DetailRowProps = {
    item: TankBatteryTableModel,
    expand: boolean
};

export function DetailRow({
    item,
    expand
}: DetailRowProps) {

    const [userState] = useUserContext();
    const [open, setOpen] = useState(expand);
    const routeContext = useRouteContext();

    const navigateTo = useNavigateTo();


    const hasDualPhase = item.tanks.some(o => o.dualPhase);

    function onNavigate(tankBatteryID: number, tankID?: number) {

        let href = '';
        if (tankID) {
            href = getTankRoute(UIViewEnum.Tank_Details, routeContext.groupID as number, undefined, tankBatteryID, tankID);
        } else {
            href = getTankBatteryRoute(UIViewEnum.TankBattery_Details, routeContext.groupID as number, tankBatteryID);
        }
        navigateTo(href);        
    }

    useEffect(() => {
        setOpen(expand);
    }, [
        expand,
        setOpen
    ]);
    
    
    return (

        <React.Fragment>
        <TableRow sx={{ 
                '& > *': { 
                    borderBottom: 'unset' 
                },
            }}>
            <CollapsibleCell 
                text={item.displayText} 
                open={open} 
                onClick={() => setOpen(!open)} 
                onTextClick={() => { onNavigate(item.id)}}/>

            <TableCell align="right">
                {item.tags?.find(o => o.tagAssociationType.id === LiquidProductionTATEnum.CapacityFilled)?.displayText ?? ''}
            </TableCell>
            <TableCell align="right">
                {item.tags?.find(o => o.tagAssociationType.id === LiquidProductionTATEnum.DailyOilProduction)?.displayText ?? ''}
            </TableCell>
            <TableCell align="right">
                {item.tags?.find(o => o.tagAssociationType.id === LiquidProductionTATEnum.DailyWaterProduction)?.displayText ?? ''}
            </TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ 
            paddingBottom: 0, 
            paddingTop: 0,
            paddingLeft: 1,
            paddingRight: 1,
            margin: 2,
            }} colSpan={5}>

            <Collapse in={open} timeout="auto" unmountOnExit>


              <Box sx={{ margin: 1 }}>

                {open &&
               

                    <Table size="small" 
                        aria-label="tank batteries" 
                        sx={{
                            backgroundColor: 'custom.background.1'
                        }}

                    >
                        <TankHeaderRow
                            //dualPhase={o.dualPhase ?? false}
                            dualPhase={hasDualPhase}
                            hasOil={false}
                            hasWater={false}
                            sx={{
                                backgroundColor: "custom.background.2",
                            }} />

                    <TableBody>
                        <>
                        {item.tanks.map((v, ndx2) => (

                        <TableRow key={ndx2} 
                            sx={{
                                backgroundColor: userState.userSettings?.theme === 'dark' || (ndx2 % 2) === 0 ? undefined : 'rgba(245, 245, 245, 1)' 
                            }}
                        >
                            <TableCell component="td" scope="row" sx={{cursor: 'pointer'}} onClick={() => {onNavigate(item.id, v.id)}}>
                                {v.displayText}
                            </TableCell>
                            <TableCell>{v.identifier}</TableCell>
                            <TableCell align="right">
                                {
                                    userState.userSettings?.tankLevelInches ?
                                    v.tags.find(x => x.tagAssociationType.id === LiquidProductionTATEnum.TopLevel)?.displayText ? 
                                        _.round(getTotalFromFeetAndInchesText(v.tags.find(x => x.tagAssociationType.id === LiquidProductionTATEnum.TopLevel)!.displayText) as number, 2) : 
                                            '' :
                                    v.tags.find(x => x.tagAssociationType.id === LiquidProductionTATEnum.TopLevel)?.displayText ?? ''
                                }
                            </TableCell>
                            {hasDualPhase && 
                            <TableCell align="right">
                                {
                                    userState.userSettings?.tankLevelInches ?
                                    v.tags.find(x => x.tagAssociationType.id === LiquidProductionTATEnum.InterfaceLevel)?.displayText ? 
                                        _.round(getTotalFromFeetAndInchesText(v.tags.find(x => x.tagAssociationType.id === LiquidProductionTATEnum.InterfaceLevel)!.displayText) as number, 2) : 
                                        '' :
                                    v.tags.find(x => x.tagAssociationType.id === LiquidProductionTATEnum.InterfaceLevel)?.displayText ?? ''
                                }
                            </TableCell>
                            }
                            <TableCell align="right">
                                {v.capacity}
                            </TableCell>
                            <TableCell align="right">
                                {v.tags.find(x => x.tagAssociationType.id === LiquidProductionTATEnum.CapacityFilled)?.displayText ?? ''}
                            </TableCell>

                        </TableRow>
                        ))
                        }

                        <TableRow sx={{
                            backgroundColor: "custom.background.2",
                            '& > td': {
                                fontWeight: 500
                            }

                        }}>
                            <TableCell component="td" scope="row">
                                {`Count: ${item.tanks.length}`}
                            </TableCell>
                            <TableCell />
                            <TableCell />
                            {hasDualPhase && <TableCell />}
                            <TableCell align="right">
                                {item.totalCapacity}
                            </TableCell>
                            <TableCell align="right">
                                {item.totalCapacityFilled}
                            </TableCell>

                        </TableRow>
                        </>
                    </TableBody>
                    </Table>

                
                }
               
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
        </React.Fragment>
    )

    
}
